import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { Home, Calendar, User, Gift, LogOut } from "lucide-react";
import { useAuth } from "./AuthContext";

export default function MemberLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate("/app/login", { replace: true });
  };

  const isActive = (path, exact = false) => {
    if (exact) return location.pathname === path || location.pathname === path + "/";
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-[#E8DCC4] pb-24" data-testid="member-app-layout">
      {/* Top header */}
      <header className="sticky top-0 z-40 bg-gradient-to-r from-[#8B2635] to-[#C97654] px-5 py-3 flex items-center justify-between shadow-lg">
        <div>
          <p className="text-[10px] uppercase tracking-[0.2em] text-white/70 font-medium">Passion Pilates</p>
          <p className="text-lg font-light text-white -mt-1">Hi {user?.name?.split(" ")[0] || "there"} 👋</p>
        </div>
        <button
          onClick={handleLogout}
          data-testid="member-logout-btn"
          className="w-9 h-9 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center transition-colors"
          aria-label="Log out"
        >
          <LogOut className="w-4 h-4 text-white" />
        </button>
      </header>

      <main className="max-w-2xl mx-auto px-5 py-6">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 left-0 right-0 bg-[#1a1a1a]/95 backdrop-blur-lg border-t border-[#2a2a2a] z-50">
        <div className="max-w-2xl mx-auto flex items-center justify-around">
          <Tab to="/app" active={isActive("/app", true)} icon={Home} label="Home" testid="tab-home" />
          <Tab to="/app/schedule" active={isActive("/app/schedule")} icon={Calendar} label="Schedule" testid="tab-schedule" />
          <Tab to="/app/referrals" active={isActive("/app/referrals")} icon={Gift} label="Refer" testid="tab-referrals" />
          <Tab to="/app/profile" active={isActive("/app/profile")} icon={User} label="Profile" testid="tab-profile" />
        </div>
      </nav>
    </div>
  );
}

function Tab({ to, active, icon: Icon, label, testid }) {
  return (
    <NavLink
      to={to}
      end={to === "/app"}
      data-testid={testid}
      className={`flex flex-col items-center justify-center py-2.5 px-4 flex-1 transition-colors ${
        active ? "text-[#C97654]" : "text-[#E8DCC4]/50 hover:text-[#E8DCC4]/80"
      }`}
    >
      <Icon className="w-5 h-5 mb-0.5" />
      <span className="text-[10px] font-medium uppercase tracking-wider">{label}</span>
    </NavLink>
  );
}
